import { TeamMemberStatus } from './enums'

export const teamMemberStatusTitles = {
  [TeamMemberStatus.Active]: 'Active',
  [TeamMemberStatus.Deactivated]: 'Deactivated',
}
